const apiRequest = (url = "", params = {}, prefix = "/api") => {
  const defaultParams = {
    headers: { "Content-Type": "application/json" },
  };

  // eslint-disable-next-line no-undef
  return fetch(`${process.env.BACKEND_URL}${prefix}/${url}`, {
    ...defaultParams,
    ...params,
  }).then((res) => {
    if (res.status === 204) {
      alert("Success!");
      return;
    }

    if (res.status === 429) {
      throw new Error('Too many requests')
    }

    return res.json();
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.error('[API] Request failed:', err);
    if (err.message === 'Too many requests') {
      throw err;
    }
    return { errors: "Network error. Please check your internet connection and try again." };
  });
};

export const getCaptchaParams = () =>
  apiRequest("captcha", {
    method: "GET",
  });

export const login = (credentials, captcha) =>
  apiRequest("sessions", {
    method: "POST",
    body: JSON.stringify({
      user: credentials,
      ...captcha,
    }),
  });

export const signup = (user, captcha) =>
  apiRequest("users", {
    method: "POST",
    body: JSON.stringify({ user, ...captcha }),
  });

export const resetPassword = (email) => apiRequest("profile/forgot-password", {
      method: "POST",
      body: JSON.stringify({ user: { email } }),
});

export const setNewPassword = (token, values) =>
  apiRequest(`profile/reset-password/${token}`, {
    method: "POST",
    body: JSON.stringify({ user: { ...values } }),
  });

export const confirmEmail = (token) =>
  apiRequest(`profile/confirm-email/${token}`, {
    method: "POST",
  });

export const helpMessage = (payload) =>
  apiRequest("send-mail", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const contactMessage = (payload) =>
  apiRequest("send-mail", {
    method: "POST",
    body: JSON.stringify(payload),
  });
